import { compose } from 'redux';
import { connect } from 'react-redux';
import Notifications from 'react-notification-system-redux';
import Form from 'react-bootstrap/Form';

const ToastNotification = ({ notifications }) => {
    return (<Notifications notifications={notifications} />);
};

const mapStateToProps = (state) => ({
    notifications: state.popUp,
});

export default compose(connect(mapStateToProps, {}))(ToastNotification);